import * as Sentry from '@sentry/vue'

export const handleError = e => {
  // ignore if request was canceled
  if (!e.response) return

  Sentry.captureException(e)

  throw e.response
}
